var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-mb-5"},[_c(_vm.installationComponent,{tag:"component",attrs:{"package-entity":_vm.packageEntity}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }